import React, { useState } from 'react';
import { Gamepad2, Home, ArrowLeft } from 'lucide-react';
import Tetris from './Tetris';
import Snake from './Snake';
import Pong from './Pong';
import MemoryMatch from './MemoryMatch';
import Game2048 from './Game2048';
import Breakout from './Breakout';
import Sudoku from './Sudoku';
import TicTacToe from './TicTacToe';
import SimonSays from './SimonSays';
import SpaceInvaders from './SpaceInvaders';
import FlappyBird from './FlappyBird';
import Hangman from './Hangman';
import Asteroids from './Asteroids';
import Minesweeper from './Minesweeper';
import TowerDefense from './TowerDefense';
import Chess from './Chess';
import CardGames from './CardGames';
import Platformer from './Platformer';
import VirtualPet from './VirtualPet';
import MazeSolver from './MazeSolver';
import IdleClicker from './IdleClicker';
import Battleship from './Battleship';
import QuizGame from './QuizGame';
import Pinball from './Pinball';

/**
 * GameOnlineMenu Component
 * Menu di selezione per tutti i giochi disponibili
 */
const GameOnlineMenu = () => {
  const [selectedGame, setSelectedGame] = useState(null);

  const games = [
    { id: 'tetris', name: 'Tetris', icon: '🎮', description: 'Classico gioco di caduta blocchi', component: Tetris, color: 'bg-primary' },
    { id: 'snake', name: 'Snake', icon: '🐍', description: 'Controlla il serpente e mangia il cibo', component: Snake, color: 'bg-success' },
    { id: 'pong', name: 'Pong', icon: '🏓', description: 'Gioco di ping pong classico', component: Pong, color: 'bg-info' },
    { id: 'memory', name: 'Memory Match', icon: '🧠', description: 'Abbina le coppie di carte', component: MemoryMatch, color: 'bg-warning' },
    { id: '2048', name: '2048', icon: '🔢', description: 'Puzzle numerico addictivo', component: Game2048, color: 'bg-danger' },
    { id: 'breakout', name: 'Breakout', icon: '🧱', description: 'Distruggi i blocchi con la palla', component: Breakout, color: 'bg-secondary' },
    { id: 'sudoku', name: 'Sudoku', icon: '📊', description: 'Puzzle logico classico', component: Sudoku, color: 'bg-info' },
    { id: 'tictactoe', name: 'Tic Tac Toe', icon: '❌', description: 'Gioco del Tris classico', component: TicTacToe, color: 'bg-primary' },
    { id: 'simon', name: 'Simon Says', icon: '🎯', description: 'Ripeti la sequenza di colori', component: SimonSays, color: 'bg-success' },
    { id: 'spaceinvaders', name: 'Space Invaders', icon: '👾', description: 'Distruggi gli alieni', component: SpaceInvaders, color: 'bg-danger' },
    { id: 'flappy', name: 'Flappy Bird', icon: '🐦', description: 'Vola tra i tubi', component: FlappyBird, color: 'bg-warning' },
    { id: 'hangman', name: 'Hangman', icon: '🎪', description: 'Indovina la parola', component: Hangman, color: 'bg-info' },
    { id: 'asteroids', name: 'Asteroids', icon: '💫', description: 'Distruggi gli asteroidi', component: Asteroids, color: 'bg-secondary' },
    { id: 'minesweeper', name: 'Minesweeper', icon: '💣', description: 'Evita le mine', component: Minesweeper, color: 'bg-success' },
    { id: 'towerdefense', name: 'Tower Defense', icon: '🏰', description: 'Difendi la tua base', component: TowerDefense, color: 'bg-danger' },
    { id: 'chess', name: 'Chess', icon: '♟️', description: 'Il gioco dei re', component: Chess, color: 'bg-primary' },
    { id: 'cardgames', name: 'Card Games', icon: '🃏', description: 'Solitario e Blackjack', component: CardGames, color: 'bg-info' },
    { id: 'platformer', name: 'Platformer', icon: '🎮', description: 'Super Mario Style', component: Platformer, color: 'bg-warning' },
    { id: 'virtualpet', name: 'Virtual Pet', icon: '🐾', description: 'Tamagotchi virtuale', component: VirtualPet, color: 'bg-success' },
    { id: 'maze', name: 'Maze Solver', icon: '🌀', description: 'Risolvi i labirinti', component: MazeSolver, color: 'bg-secondary' },
    { id: 'clicker', name: 'Idle Clicker', icon: '⭐', description: 'Guadagna cliccando', component: IdleClicker, color: 'bg-danger' },
    { id: 'battleship', name: 'Battleship', icon: '⚓', description: 'Affonda le navi nemiche', component: Battleship, color: 'bg-info' },
    { id: 'quiz', name: 'Quiz Game', icon: '❓', description: 'Testa le tue conoscenze', component: QuizGame, color: 'bg-primary' },
    { id: 'pinball', name: 'Pinball', icon: '🎯', description: 'Gioco del flipper', component: Pinball, color: 'bg-warning' }
  ];

  // Se è selezionato un gioco, mostra il gioco
  if (selectedGame) {
    const game = games.find(g => g.id === selectedGame);
    const GameComponent = game.component;
    return (
      <div>
        <button
          onClick={() => setSelectedGame(null)}
          className="btn btn-secondary mb-4"
          aria-label="Back to games menu"
        >
          <ArrowLeft size={20} className="me-2" />
          Torna al Menu Giochi
        </button>
        <GameComponent />
      </div>
    );
  }

  // Mostra il menu di selezione giochi
  return (
    <div className="container mt-5">
      {/* Header */}
      <header className="game-online-header mb-5">
        <div className="d-flex align-items-center gap-3 mb-3">
          <Gamepad2 size={40} className="text-white" aria-hidden="true" />
          <div>
            <h1 className="mb-0">Game Online</h1>
            <p className="mb-0 text-white-50">Seleziona un gioco e inizia a giocare</p>
          </div>
        </div>
      </header>

      {/* Games Grid */}
      <section className="games-grid" aria-label="Available games">
        {games.map((game) => (
          <article
            key={game.id}
            className="game-card"
            role="button"
            tabIndex="0"
            onClick={() => setSelectedGame(game.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setSelectedGame(game.id);
              }
            }}
            aria-label={`Play ${game.name}: ${game.description}`}
          >
            <div className={`game-card-icon ${game.color}`}>
              <span style={{ fontSize: '2.5rem' }}>{game.icon}</span>
            </div>
            <h2 className="game-card-title">{game.name}</h2>
            <p className="game-card-description">{game.description}</p>
            <div className="game-card-footer">
              <button
                className="btn btn-sm btn-primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedGame(game.id);
                }}
                aria-label={`Start playing ${game.name}`}
              >
                Gioca Ora
              </button>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default GameOnlineMenu;
